import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const UserApiUtils = {
  fetchOne(id) {
    return xhr(ApiConstants.FetchUser + id).then((json) => json);
  },
};

export default UserApiUtils;
